import React from 'react';
import cn from 'classnames';
import './Columns.scss';



export default React.createClass({
    propTypes: {
        layout: React.PropTypes.oneOf(['equal', 'l_sidebar', 'r_sidebar']),
        sb_style: React.PropTypes.oneOf(['flex', 'fixed']),
    },
    getDefaultProps() {
        return {
            layout: 'equal',
        };
    },
    render() {
        const layout = this.props.layout;
        const sb_style = this.props.sb_style;
        const classes = cn([
            'col_layout',
            `cl--${layout}`,
            sb_style ? `cl--sidebar_${sb_style}` : '',
            this.props.className
        ]);
        return <div className={classes}>{this.props.children}</div>;
    }
});



/** WEBPACK FOOTER **
 ** core/client/rawr/layout/Columns.jsx
 **/